import { DocumentData } from "firebase/firestore";

export function PaymentSuccessScreen({ event }: { event: DocumentData }) {
  return (
    <div className='payment-complete-container'>
      <h6>Payment successful!</h6>
      <h2>You’ll be attending {event?.title}</h2>
      <p className='payment-complete-container_description'>
        A confirmation has been sent to your email. You can now access your
        ticket in the Ding Wallet app.
      </p>
      <div className='download-container'>
        <p>Here’s a step by step process to access your ticket:</p>
        <ul>
          <li>
            Download the Ding wallet app on app store or play store.
            <div className='download-buttons'>
              <button
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/us/app/ding-wallet-event-tickets/id6742137257",
                    "_blank"
                  )
                }
              >
                <i className='bi bi-apple'></i>Apple Store
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.ding.wallet.app&pli=1",
                    "_blank"
                  )
                }
              >
                <i className='bi bi-google-play'></i>Play store
              </button>
            </div>
          </li>
          <li>
            Log in with the same email you registered with for the conference.
          </li>
          <li>Create a secure passcode, and you’re all set!</li>
        </ul>
        <a
          href='https://drive.google.com/uc?export=download&id=1Mq7HVQrdimV9GRo_gAsB7Zdwa3TT0mWn'
          target='_blank'
          className='download-container-link'
          rel='noreferrer'
        >
          Click here to view HOW TO document
        </a>
      </div>
    </div>
  );
}
